module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_m_leucistic.858afa27.png";